// translations.js — EN/ES strings for UI labels

export const TRANSLATIONS = {
  en: {
    nav: {
      services: "Services",
      portfolio: "Portfolio",
      howItWorks: "How It Works",
      pricing: "Pricing",
      testimonials: "Testimonials",
      contact: "Contact",
    },
    howItWorks: {
      sectionTitle: "How It Works",
      steps: [
        {
          icon: "💬",
          title: "Contact & Brief",
          desc: "We discuss your goals and plan the right website solution for your business.",
        },
        {
          icon: "🎨",
          title: "Design & Build",
          desc: "We design and develop a modern, fast and SEO-friendly website while staying in close communication with you.",
        },
        {
          icon: "🚀",
          title: "Delivery & Launch",
          desc: "We launch your website and continue supporting your online growth.",
        },
      ],
    },
    services: {
      sectionTitle: "Our Services",
      sectionSubtitle: "From landing pages to full business websites, we build modern digital solutions.",
    },
    portfolio: {
      sectionTitle: "Our Work",
      sectionSubtitle: "Explore our latest web design and development projects.",
      viewProject: "View Project",
    },
    pricing: {
      sectionTitle: "Pricing",
      sectionSubtitle: "Transparent, all-inclusive pricing with no hidden fees.",
      recommended: "Recommended",
      getStarted: "Get Started",
    },
    testimonials: {
      sectionTitle: "What Clients Say",
    },
    contact: {
      orReach: "Or reach us directly",
      whatsapp: "WhatsApp",
    },
    footer: {
      rights: "All rights reserved.",
      language: "Language",
    },
    modal: {
      close: "Close",
      prevImage: "Previous",
      nextImage: "Next",
      prevProject: "← Previous Project",
      nextProject: "Next Project →",
    },
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    admin: "Admin",
    subServices: "Sub-services:",
  },
  es: {
    nav: {
      services: "Servicios",
      portfolio: "Portafolio",
      howItWorks: "Cómo Funciona",
      pricing: "Precios",
      testimonials: "Testimonios",
      contact: "Contacto",
    },
    howItWorks: {
      sectionTitle: "Cómo Funciona",
      steps: [
        {
          icon: "💬",
          title: "Contacto y Briefing",
          desc: "Rellena el formulario, hablamos de tu proyecto y aclaramos juntos tus objetivos, audiencia y requisitos técnicos.",
        },
        {
          icon: "🎨",
          title: "Diseño y Desarrollo",
          desc: "Creamos tu sitio con React, Tailwind y herramientas asistidas por IA. Revisamos iteraciones hasta que quedes satisfecho.",
        },
        {
          icon: "🚀",
          title: "Entrega y Lanzamiento",
          desc: "Desplegamos tu sitio, realizamos pruebas en escritorio/móvil/SEO y te entregamos acceso completo con documentación.",
        },
      ],
    },
    services: {
      sectionTitle: "Nuestros Servicios",
      sectionSubtitle: "Todo lo que necesitas para establecer, crecer y convertir en internet.",
    },
    portfolio: {
      sectionTitle: "Nuestro Trabajo",
      sectionSubtitle: "Una selección curada de proyectos recientes de los que estamos orgullosos.",
      viewProject: "Ver Proyecto",
    },
    pricing: {
      sectionTitle: "Precios",
      sectionSubtitle: "Precios transparentes y completos, sin costes ocultos.",
      recommended: "Recomendado",
      getStarted: "Empezar",
    },
    testimonials: {
      sectionTitle: "Lo Que Dicen Nuestros Clientes",
    },
    contact: {
      orReach: "O contáctanos directamente",
      whatsapp: "WhatsApp",
    },
    footer: {
      rights: "Todos los derechos reservados.",
      language: "Idioma",
    },
    modal: {
      close: "Cerrar",
      prevImage: "Anterior",
      nextImage: "Siguiente",
      prevProject: "← Proyecto Anterior",
      nextProject: "Siguiente Proyecto →",
    },
    darkMode: "Modo Oscuro",
    lightMode: "Modo Claro",
    admin: "Admin",
    subServices: "Sub-servicios:",
  },
};
